import React from 'react';
import './Features.scss';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

const Features: React.FC = () => {
  const features: Feature[] = [
    {
      icon: '/Track anything.svg',
      title: 'Track Anything',
      description: 'From cars to yachts, motorcycles to bicycles - protect any valuable asset with invisible tracking.'
    },
    {
      icon: '/Real-time Tracking.svg',
      title: 'Real-time Tracking',
      description: 'Get instant location updates and live tracking when you need it most. Always know where your assets are.'
    },
    {
      icon: '/Global coverage.svg',
      title: 'Global Coverage',
      description: 'CATM 4G connectivity ensures your tracker works anywhere with cellular coverage worldwide.'
    },
    {
      icon: '/Peace of mind.svg',
      title: 'Peace of Mind',
      description: 'Sleep better knowing your valuable assets are protected 24/7 with undetectable monitoring.'
    },
    {
      icon: '/Track more for less.svg',
      title: 'Track More for Less',
      description: '24 months battery life and affordable pricing means maximum protection with minimal ongoing costs.'
    },
    {
      icon: '/Stay insured.svg',
      title: 'Stay Insured',
      description: 'Many insurance companies offer discounts for GPS tracking. Protect your assets and save money.'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <h2>Why Choose Shadow Tracker?</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <img src={feature.icon} alt={feature.title} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
